import { getRootAppWindow } from "meta/utils/getRootAppWindow";
import { openNotifications } from "../../actions/notificationsActions";
import { useDispatch } from "react-redux";
import { useRootSelector } from "../useAppSelector";
const focusableElementsSelector = 'button:not([tabindex="-1"]), a[href], input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
const activeIframeSelector = 'iframe[data-active="true"]';
const activeDockedIframeSelector = 'iframe[data-docked-active="true"]';
export const useFocus = () => {
    const rootWindow = getRootAppWindow(window);
    const getActiveContentTab = (docked = false) => {
        const iframe = rootWindow.document.querySelector(docked ? activeDockedIframeSelector : activeIframeSelector);
        if (!iframe || !iframe.contentDocument) {
            throw "Could not find active iframe";
        }
        return iframe;
    };
    const focusHeader = () => {
        const focusableElements = rootWindow.document.querySelectorAll(focusableElementsSelector);
        const first = focusableElements[0];
        first.focus();
    };
    const focusMainTab = () => {
        const activeContentTab = getActiveContentTab();
        const insideIframe = activeContentTab.contentDocument.querySelector(activeIframeSelector);
        const first = insideIframe.contentDocument.querySelectorAll(focusableElementsSelector)[0];
        activeContentTab.focus();
        insideIframe.focus();
        first.focus();
    };
    const focusChartTabs = () => {
        const activeContentTab = getActiveContentTab();
        const chartTabsContainerSelector = '[data-identification="chart-tabs-container"]';
        const chartTabsContainer = activeContentTab.contentDocument?.querySelector(chartTabsContainerSelector);
        if (!chartTabsContainer) {
            console.warn("Could not find Chart Tabs");
            return;
        }
        const first = chartTabsContainer.querySelectorAll(focusableElementsSelector)[0];
        activeContentTab.focus();
        first.focus();
    };
    const focusPatientHeader = () => {
        const patientHeaderContainerSelector = "table.patientHeaderTable";
        const activeContentTab = getActiveContentTab();
        const patientHeaderContainer = activeContentTab.contentDocument?.querySelector(patientHeaderContainerSelector);
        if (!patientHeaderContainer) {
            console.warn("Could not find Patient Header");
            return;
        }
        const first = patientHeaderContainer.querySelector("a");
        activeContentTab.focus();
        first?.focus();
    };
    const { isLogged } = useRootSelector();
    const dispatch = useDispatch();
    const focusNotificationCenter = () => {
        if (!isLogged) {
            console.warn("Cannot open Notification Center before logging in");
            return;
        }
        dispatch(openNotifications(true));
        const activeDocked = getActiveContentTab(true);
        const insideIframe = activeDocked.contentDocument.querySelector(activeIframeSelector);
        if (!insideIframe?.contentDocument) {
            console.warn("Inside iframe could not be found");
            return;
        }
        const first = insideIframe.contentDocument.querySelectorAll(focusableElementsSelector)[0];
        activeDocked.focus();
        insideIframe.focus();
        first.focus();
    };
    return {
        focusHeader,
        focusMainTab,
        focusChartTabs,
        focusPatientHeader,
        focusNotificationCenter,
    };
};
